// extracted by mini-css-extract-plugin
export default {"partRow":"ProcessItemPart_partRow__syAeG","form-check-input":"ProcessItemPart_form-check-input__-ptXl"};